import React, { FunctionComponent, ReactNode } from 'react';
import {
  Modal as BSModal,
  ModalProps as BSModalProps,
  ModalHeaderProps as BSModalHeaderProps,
  ModalTitleProps as BSModalTitleProps,
  ModalBodyProps as BSModalBodyProps,
  ModalFooterProps as BSModalFooterProps,
} from 'react-bootstrap';

interface ModalProps {
  className?: string;
}

const Modal: FunctionComponent<ModalProps & BSModalProps> = ({
  children,
  ...props
}) => (
  <BSModal data-cy="modal-popup" {...props}>
    <div className="color-line" />
    {children}
  </BSModal>
);

export default Modal;

interface ModalChildrenProps {
  children?: ReactNode;
  className?: string;
}

export const ModalHeader: FunctionComponent<
  ModalChildrenProps & BSModalHeaderProps
> = ({ children, ...props }) => (
  <BSModal.Header {...props}>{children}</BSModal.Header>
);

export const ModalTitle: FunctionComponent<
  ModalChildrenProps & BSModalTitleProps
> = ({ children, ...props }) => (
  <BSModal.Title {...props}>{children}</BSModal.Title>
);

export const ModalBody: FunctionComponent<
  ModalChildrenProps & BSModalBodyProps
> = ({ children, ...props }) => (
  <BSModal.Body {...props}>{children}</BSModal.Body>
);

export const ModalFooter: FunctionComponent<
  ModalChildrenProps & BSModalFooterProps
> = ({ children, ...props }) => (
  <BSModal.Footer {...props}>{children}</BSModal.Footer>
);
